<div class="tab-content" [class.loading]="loading">
  @if (loading) {
    <i class="fa-solid fa-spinner fa-spin tab-loading-spinner"></i>
  }
  @if (!loading) {
    <p class="double-margin-bottom">
      The tags defined here will be applied to resources {{ uiService.productName }} creates that are not replicated
      from the primary environment. Use these settings to satisfy Service Control Policies that require specific tags.
    </p>
    <form [formGroup]="tagSettingsFormModel" (ngSubmit)="updateResourceTags()" class="margin-top">
      <account-tags-form-control formControlName="resourceTags"></account-tags-form-control>
      <button
        busy-button
        [busy]="submitting"
        [done]="doneSubmitting"
        class="arpio-button margin-left margin-top"
        type="submit"
        [disabled]="updateButtonDisabled"
      >
        SAVE
      </button>
    </form>
  }
</div>
